var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b',[_c('small',[_vm._v(_vm._s(_vm.$t('a')))])]),_c('ais-refinement-list',{attrs:{"attribute":"profile.languages.code","transform-items":_vm.transformItems,"operator":"and"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }